import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/OnboardingStep1Page.css';
import { useAuth } from '../context/AuthContext';
import { updateUserIcon } from '../services/userService';

const OnboardingStep1Page: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [selectedIcon, setSelectedIcon] = useState<string>('');
  const [loading, setLoading] = useState(false);

  // Array of available user icons
  const userIcons = [
    'userIcon_alien.png',
    'userIcon_basket.png',
    'userIcon_devil.png',
    'userIcon_donut.png',
    'userIcon_fire.png',
    'userIcon_ghost.png',
    'userIcon_owl.png',
    'userIcon_planet.png',
    'userIcon_robot.png'
  ];

  const handleIconSelect = (icon: string) => {
    setSelectedIcon(icon);
  };

  const handleNext = async () => {
    if (!selectedIcon) {
      alert('Vælg venligst en ikon');
      return;
    }

    if (!currentUser) {
      navigate('/login');
      return;
    }

    try {
      setLoading(true);
      await updateUserIcon(currentUser.uid, selectedIcon);
      navigate('/onboarding/step-2');
    } catch (error) {
      console.error('Error saving user icon:', error);
      alert('Der opstod en fejl. Prøv venligst igen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="onboarding-step1-page">
      {/* Background Image */}
      <div className="background-image"></div>

      {/* Logo */}
      <img src="/images/logo.png" alt="Wiin Logo" className="onboarding-logo" />

      {/* Title */}
      <h1 className="onboarding-title">Vælg din personlige ikon</h1>

      {/* Icon Grid */}
      <div className="icon-grid">
        {userIcons.map((icon, index) => (
          <div
            key={index}
            className={`icon-container ${selectedIcon === icon ? 'selected' : ''}`}
            onClick={() => handleIconSelect(icon)}
          >
            <div className="icon-gradient-circle">
              <img src={`/images/${icon}`} alt={`Icon ${index + 1}`} className="icon-image" />
            </div>
          </div>
        ))}
      </div>

      {/* Progress Indicator */}
      <div className="progress-indicator">
        <img src="/images/onboarding_1.png" alt="Step 1 of 3" className="progress-image" />
      </div>

      {/* Next Button */}
      <div className="button-container">
        <button 
          className="next-button" 
          onClick={handleNext}
          disabled={loading || !selectedIcon}
        >
          <span>{loading ? 'Gemmer...' : 'Næste'}</span>
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.67 9.07L23.67 13.35L18.67 17.63"
              stroke="#FFFFFF"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.09 13.35H23.67"
              stroke="#FFFFFF"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default OnboardingStep1Page;
